import React from 'react';
import {
    Box,
    Paper,
    Typography,
    Button,
    Link
} from '@mui/material';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { useParams } from 'react-router-dom';
import { enterpriseGridOverrideTheme } from '../../themes/EnterpriseGridTheme';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const ClassificationDetailTemp = () => {
    const { id } = useParams();

    // Dataset 1 - Original data
    const dataset1 = [
        {
            id: 1,
            class: 'A',
            total: 1349,
            changed: 131,
            updatedPercent: 9.71
        },
        {
            id: 2,
            class: 'B',
            total: 3486,
            changed: 910,
            updatedPercent: 26.10
        },
        {
            id: 3,
            class: 'C',
            total: 51391,
            changed: 752,
            updatedPercent: 1.46
        },
        {
            id: 4,
            class: 'D',
            total: 992875,
            changed: 931,
            updatedPercent: 0.09
        }
    ];

    // Dataset 2 - Alternative data
    const dataset2 = [
        {
            id: 1,
            class: 'A',
            total: 1717,
            changed: 180,
            updatedPercent: 10.48
        },
        {
            id: 2,
            class: 'B',
            total: 3045,
            changed: 390,
            updatedPercent: 12.81
        },
        {
            id: 3,
            class: 'C',
            total: 51929,
            changed: 993,
            updatedPercent: 1.91
        },
        {
            id: 4,
            class: 'D',
            total: 992462,
            changed: 149,
            updatedPercent: 0.02
        }
    ];

    // Dataset 2 - Alternative data
    const dataset3 = [
        {
            id: 1,
            class: 'A',
            total: 1668,
            changed: 23,
            updatedPercent: 1.38
        },
        {
            id: 2,
            class: 'B',
            total: 3304,
            changed: 69,
            updatedPercent: 2.09
        },
        {
            id: 3,
            class: 'C',
            total: 51346,
            changed: 142,
            updatedPercent: 0.28
        },
        {
            id: 4,
            class: 'D',
            total: 992884,
            changed: 129,
            updatedPercent: 0.01
        }
    ];

    // Dataset 2 - Alternative data
    const dataset4 = [
        {
            id: 1,
            class: 'A',
            total: 1668,
            changed: 29,
            updatedPercent: 1.7
        },
        {
            id: 2,
            class: 'B',
            total: 3304,
            changed: 128,
            updatedPercent: 3.87
        },
        {
            id: 3,
            class: 'C',
            total: 51348,
            changed: 263,
            updatedPercent: 0.51
        },
        {
            id: 4,
            class: 'D',
            total: 992891,
            changed: 215,
            updatedPercent: 0.02
        }
    ];

    const dataset5 = [
        {
            id: 1,
            class: 'A',
            total: 1678,
            changed: 31,
            updatedPercent: 1.8
        },
        {
            id: 2,
            class: 'B',
            total: 3279,
            changed: 79,
            updatedPercent: 2.4
        },
        {
            id: 3,
            class: 'C',
            total: 51389,
            changed: 200,
            updatedPercent: .38
        },
        {
            id: 4,
            class: 'D',
            total: 992912,
            changed: 103,
            updatedPercent: .01
        }
    ];

    // Function to get appropriate dataset based on ID
    const getDataset = (paramId) => {
        switch (paramId) {
            case '1':
                return dataset1;
            case '2':
                return dataset2;
            case '3':
                return dataset3;
            case '4':
                return dataset4;
            case '5':
                return dataset5;
            default:
                return dataset1; // Fallback to dataset1
        }
    };

    // Get the appropriate dataset
    const selectedData = getDataset(id);

    // Pre-formatted data for display
    const formattedSummaryData = selectedData.map(row => ({
        id: row.id,
        class: row.class,
        total: row.total.toLocaleString(),
        changed: row.changed.toLocaleString(),
        updatedPercent: `${row.updatedPercent}%`
    }));

    const columns = [
        {
            field: 'class',
            headerName: 'Class',
            width: 100
        },
        {
            field: 'total',
            headerName: 'Total',
            width: 150
        },
        {
            field: 'changed',
            headerName: 'Changed',
            width: 150
        },
        {
            field: 'updatedPercent',
            headerName: '% Updated',
            width: 150,
            align: 'right',
            headerAlign: 'right'
        }
    ];

    // Different PowerBI links based on ID (you can customize these)
    const getPowerBiLinks = (paramId) => {
        switch (paramId) {
            case '1':
                return {
                    detailsLink: "https://app.powerbi.com/links/U1clTQboYm?ctid=33b1ca7f-20ff-4f96-8e27-74acdd92e4bf&pbi_source=linkShare&bookmarkGuid=3a86232e-a4bb-4a64-9bd2-bb2dd41a2990",
                    explainerLink: "https://app.powerbi.com/links/SR4dw7lpUG?ctid=33b1ca7f-20ff-4f96-8e27-74acdd92e4bf&pbi_source=linkShare"
                };
            case '2':
                return {
                    detailsLink: "https://app.powerbi.com/links/nM2eOUOwgp?ctid=33b1ca7f-20ff-4f96-8e27-74acdd92e4bf&pbi_source=linkShare", // Replace with actual link
                    explainerLink: "https://app.powerbi.com/links/ifiDv1npaJ?ctid=33b1ca7f-20ff-4f96-8e27-74acdd92e4bf&pbi_source=linkShare" // Replace with actual link
                };
            case '3':
                return {
                    detailsLink: "https://app.powerbi.com/links/5bTEpz_DHH?ctid=33b1ca7f-20ff-4f96-8e27-74acdd92e4bf&pbi_source=linkShare", // Replace with actual link
                    explainerLink: "https://app.powerbi.com/links/Q6juxtjFp0?ctid=33b1ca7f-20ff-4f96-8e27-74acdd92e4bf&pbi_source=linkShare" // Replace with actual link
                };
            case '4':
                return {
                    detailsLink: "https://app.powerbi.com/links/ppwH84VAdb?ctid=33b1ca7f-20ff-4f96-8e27-74acdd92e4bf&pbi_source=linkShare", // Replace with actual link
                    explainerLink: "https://app.powerbi.com/links/9U4ivD57yi?ctid=33b1ca7f-20ff-4f96-8e27-74acdd92e4bf&pbi_source=linkShare" // Replace with actual link
                };
            case '5':
                return {
                    detailsLink: "https://app.powerbi.com/links/Bxj4lb72WK?ctid=33b1ca7f-20ff-4f96-8e27-74acdd92e4bf&pbi_source=linkShare", // Replace with actual link
                    explainerLink: "https://app.powerbi.com/links/howUJV9f_C?ctid=33b1ca7f-20ff-4f96-8e27-74acdd92e4bf&pbi_source=linkShare" // Replace with actual link
                };
            default:
                return {
                    detailsLink: "https://app.powerbi.com/links/U1clTQboYm?ctid=33b1ca7f-20ff-4f96-8e27-74acdd92e4bf&pbi_source=linkShare&bookmarkGuid=3a86232e-a4bb-4a64-9bd2-bb2dd41a2990",
                    explainerLink: "https://app.powerbi.com/links/SR4dw7lpUG?ctid=33b1ca7f-20ff-4f96-8e27-74acdd92e4bf&pbi_source=linkShare"
                };
        }
    };

    const { detailsLink, explainerLink } = getPowerBiLinks(id);

    // Dynamic title based on ID
    const getTitle = (paramId) => {
        switch (paramId) {
            case '1':
                return "4/17/2025 Part Classification";
            case '2':
                return "5/15/2025 Part Classification";
            case '3':
                return "6/19/2025 Part Classification";
            case '4':
                return "7/17/2025 Part Classification";
            case '5':
                return "8/21/2025 Part Classification";
            default:
                return "Part Classification";
        }
    };

    return (
        <Paper elevation={3} sx={{ p: 3, maxWidth: '100%', mt: 4 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Typography variant="h1" component="h1" gutterBottom align="left">
                    {getTitle(id)}
                </Typography>

                <Box sx={{ display: 'flex', gap: 2 }}>
                    <Button
                        variant="contained"
                        color="primary"
                        endIcon={<OpenInNewIcon />}
                        component={Link}
                        href={detailsLink}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Classification Details
                    </Button>

                    <Button
                        variant="contained"
                        color="primary"
                        endIcon={<OpenInNewIcon />}
                        component={Link}
                        href={explainerLink}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Part Classification Explainer
                    </Button>
                </Box>
            </Box>

            <Box sx={{ height: 300 }}>
                <DataGrid
                    sx={enterpriseGridOverrideTheme}
                    rows={formattedSummaryData}
                    columns={columns}
                    density="compact"
                    disableRowSelectionOnClick
                    slots={{ toolbar: GridToolbar }}
                    slotProps={{
                        toolbar: {
                            showQuickFilter: true,
                            quickFilterProps: { debounceMs: 500 },
                            csvOptions: { fileName: `classification_summary_${id}_export` },
                            printOptions: { fileName: `classification_summary_${id}_export` }
                        }
                    }}
                />
            </Box>
        </Paper>
    );
};

export default ClassificationDetailTemp;